<template>
    <div>
            
        <transition name="fade">
            <div v-if="updatingItem" class="loading">
                <p>Updating...</p>
            </div>
        </transition>
        
        <b-modal no-fade size="l" id="modal-quantityexceeds" ok-only title="Error" ok-title="OK">
            Please check that all fields are entered correctly  
        </b-modal>

        <b-container fluid>
            
            <!------------------------------------->
            <!-- Add a beverage -->
            <!------------------------------------->
            <b-row>
                <b-col style="margin-top:20px; text-align:center">
                    <b-button size="lg"  class="m-md-2" variant="warning" @click="$router.push('selecttype')">
                        <font-awesome-icon icon="plus" /> <font-awesome-icon icon="beer" />  Add a Beverage 
                    </b-button>
                </b-col>
            </b-row>


            <!-- Fake call to setup shipping and delivery -->
            {{setupShippingDelivery}}

            <!-- Modal error when consumer enabled, but no shipping selected -->
            <b-modal no-fade id='modal-errorconsumer' ok-only title="Error" ok-title="OK">
                Please select at least one of delivery, pickup or shipping when selling to consumers  
            </b-modal>

             <!-- Modal to show terms of sale -->
            <b-modal size="xl" no-fade id='modaltermsofsale' ok-only title="Terms of sale" ok-title="OK">
                <sellerterms />
            </b-modal>

            <!------------------------------------->
            <!-- Inventory quick view-->
            <!------------------------------------->
            <table class="table table-bordered" style="background-color:#f2f2f2">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col"><small>Name</small></th>
                        <th scope="col"><small>Keg1</small></th>
                        <th scope="col"><small>Keg2</small></th>
                        <th scope="col"><small>Cans</small></th>
                        <th scope="col"><small>Bottles</small></th>
                        <th scope="col"><small>Post Off</small></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item) in userInventory" :key="item.id">
                        <td><b-button variant="outline-dark" size="sm" @click="goToGeer(item.id)">{{item.beerName}}</b-button></td>
                        <td v-if="item.barrel1Quantity" style="color:#2e5189; background-color:#c0c0c0"><strong>{{item.barrel1Quantity}}</strong></td>
                        <td v-else><small style="color:gray">n/a</small></td>
                        <td v-if="item.barrel2Quantity" style="color:#2e5189; background-color:#c0c0c0"><strong>{{item.barrel2Quantity}}</strong></td>
                        <td v-else><small style="color:gray">n/a</small></td>
                        <td v-if="item.canQuantity" style="color:#2e5189; background-color:#c0c0c0"><strong>{{item.canQuantity}}</strong></td>
                        <td v-else><small style="color:gray">n/a</small></td>
                        <td v-if="item.bottleQuantity" style="color:#2e5189; background-color:#c0c0c0"><strong>{{item.bottleQuantity}}</strong></td>
                        <td v-else><small style="color:gray">n/a</small></td>
                        <td v-if="item.ispostoffering"><small style="color:red"><b>YES</b></small></td>
                        <td v-else><small style="color:gray">NO</small></td>

                    </tr>
                </tbody>
            </table>

            <!-- Inventory Collapse -->
            <b-row>
                <b-col style="margin-top:20px">
                    <h3>Your Inventory</h3>
                </b-col>
            </b-row>
            <!-- Iterate over all items -->
            <template v-for="(item) in userInventory"> 
                <!------------------------------->
                <!-- Collapse button for beer --->
                <!------------------------------->
                <div :key='item.id+"divcollapse"' :id='"beercomponentbuttondiv"+item.id'>
                    <b-row :key="item.id">
                        <b-col>
                            <div style='margin-top:10px; margin-bottom:10px; margin-left:10px; width:75%'>
                                <b-button v-b-toggle="'collapse-beer'+item.id" class="btn btn-secondary" type="button"> 
                                    {{item.beerName}} <font-awesome-icon icon="caret-down" />
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <!----------------------------->
                <!-- Inventory Collapse -->
                <!----------------------------->
                <div :key='item.id+"div"' :id='"beercomponentdiv"+item.id'>
                    <b-collapse :id="'collapse-beer'+item.id" :key='item.id+"coll"'>
                        <Beerinventorycomponent :theOrigBeer="item" :id="item.id" :key="item.id+'beercomponent'"/>
                    </b-collapse>
                </div>

            </template>

            <!------------------------------------->
            <!-------------- Sales Sheet ---------->
            <!------------------------------------->
            <b-card
                bg-variant="light" 
                border-variant="secondary"
                class="mb-2"
                header='(Optional) Upload a Sales Sheet (PDF format only)'
                
                >
                <b-row>
                    <b-col>
                        <uploadimage uploadPreset="salessheetdpdf" :uploadComplete="salesSheetUploadComplete" :fileFormatArray="fileFormatArray" :fileFormatError="fileFormatError"/>
                    </b-col>
                    <b-col>
                        <b-button v-if="userProfile.salesSheetPdfUrl" v-b-modal.modal-salespdf>Show Sales Sheet</b-button>
                    </b-col>
                    <b-col>
                        <pdf style="width:100px; " :src="userProfile.salesSheetPdfUrl"></pdf>
                    </b-col>
                </b-row>
                <b-row>
                    <strong>Note: This sales sheet DOES NOT add the items to your Kegseeker inventory. The sales sheet will be visible to buyers, but buyers cannot order off of the sales sheet. 
                    <br>For ordering, please add the beverages to your Kegseeker inventory.</strong>
                </b-row>

            </b-card>

            <!-- Sales PDF Sheet -->
            <b-modal no-fade size="xl" id="modal-salespdf" ok-only title="Sales Sheet" ok-title="OK">
                <pdf :src="userProfile.salesSheetPdfUrl"></pdf>
            </b-modal>
            
            <!-- File format error -->
            <b-modal header-bg-variant="danger" no-fade id="modal-fileformaterror" ok-only title="File Format Error" ok-title="OK">
                Please upload only PDF files
            </b-modal>

        </b-container>
        <div id="footerid">
        <footer><pagefooter/></footer>
        </div>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import Pagefooter from './Pagefooter'
    import Addinventorycomponent from './Addinventorycomponent'
    import Beerinventorycomponent from './Beerinventorycomponent'
    import Uploadimage from './Uploadimage'
    import Sellerterms from './seller/Sellerterms'
    import { deliveryAgents } from './Myfunctions'
    import pdf from 'vue-pdf'

    export default {
        components: {
            Pagefooter,
            Addinventorycomponent,
            Beerinventorycomponent,
            Sellerterms,
            pdf,
            Uploadimage
        },
        data() {
            return {
                beer:{
                    beerName:'',
                    quantity:'',
                    abv:'',
                    type:null,
                    description:'',
                    cost:'',
                    availableDate:'',
                    size:'',
                    container:'',
                    cansPerCase:'',
                    ozPerCan:'',
                    ozPerBottle:'',
                    bottlesPerCase:'',
                    subType:'',
                },
                otherDeliveryMethod:'',        
                containerOptions: [
                    { text: 'Keg', value: 'keg' },
                    { text: 'Can', value: 'cans' },
                    { text: 'Bottle', value: 'bottles' }
                ],
                typeOptions: [
                    { text: 'IPA', value: 'IPA' },
                    { text: 'Pale Ale', value: 'Pale Ale' },
                    { text: 'Golden Ale', value: 'Golden Ale' },
                    { text: 'Stout', value: 'Stout' },
                    { text: 'Porter', value: 'Porter' },
                    { text: 'Lager', value: 'Lager' },
                    { text: 'Pilsner', value: 'Pilsner' },
                    { text: 'Saison', value: 'Saison' },
                    { text: 'Other', value: 'Other' },

                ],
                showSuccess: false,
                showDateWarning: false,
                updatingItem: false,
                barrelSizeOptions: [
                    { value: '1/2 Barrel, 15.5 Gal', text: '1/2 Barrel, 15.5 Gal'},
                    { value: '13.2 Gal, 50L', text: '13.2 Gal, 50L'},
                    { value: '1/4th Barrel, 7.75 Gal', text: '1/4th Barrel, 7.75 Gal'},
                    { value: '1/6th Barrel 5.16 Gal', text: '1/6th Barrel, 5.16 Gal'},
                    ],

                    maxDescriptionLength:200,
                    invalidName:false,
                    invalidQuantity:false,
                    invalidSize:false,
                    invalidType:false,
                    invalidCost:false,
                    invalidABV:false,
                    invalidDate:false,
                    showAddBeerError:false,
                    invalidContainer:false,
                    invalidCanSize:false,
                    invalidBottleSize:false,
                    consumerDeliveryFees:"",
                    consumerDeliveryTime:"",
                    consumerShippingTime:"",
                    minForFreeDelivery:"",
                    minForFreeShipping:"",
                    invalidDeliveryTime:false,
                    invalidShippingTime:false,
                    invalidDeliveryFees:false,
                    invalidShippingFees:false,
                    invalidMinimumDelivery:false,
                    invalidMinimumFreeShipping:false,
                    invalidKegDeposit:false,
                    consumerEntryError:false,
                    hasError:false,
                    case1ShippingSize:null,
                    case1ShippingCost:" ",
                    case2ShippingSize:null,
                    case2ShippingCost:" ",
                    case3ShippingSize:null,
                    case3ShippingCost:" ",
                    case4ShippingSize:null,
                    case4ShippingCost:" ",
                    caseSizeOptions: [
                        { value: null, text: "Select number of cases"},
                        { value: '1', text: '1'},
                        { value: '2', text: '2'},
                        { value: '3', text: '3'},
                        { value: '4', text: '4'},
                        { value: '5', text: '5'},
                        { value: '6', text: '6'},
                        { value: '7', text: '7'},
                        { value: '8', text: '8'},
                    ],
                    case1Error:false,
                    case2Error:false,
                    case3Error:false,
                    case4Error:false,
                    sellToConsumers:false,
                    willShip:0,
                    willDeliver:0,
                    willPickup:0,
                    pickupAddress:'',
                    kegDeposit:0,
                    allowConsumerSales:false,
                    salesPDFLink:'https://res.cloudinary.com/lo4xxr5lr/image/upload/v1609875136/kegseekersalessheets/Independent_Contractor_Liability_Waiver_Form.pdf',
                    fileFormatArray:['pdf'],
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'userInventory', 'promotionsEnabled', 'allowConsumers']),
            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },

            //Setup shipping/delivery from userProfile
            setupShippingDelivery(){
                
                //Check if consumers allowed
                if (this.userProfile.sellToConsumers==1) this.sellToConsumers = true
                else this.sellToConsumers = false

                if(this.userProfile.willShip==1) this.willShip = 1
                else this.willShip = 0
                if(this.userProfile.willDeliver==1) this.willDeliver = 1
                else this.willDeliver = 0
                if(this.userProfile.willPickup==1) this.willPickup = 1
                else this.willPickup = 0
            
                
                if(this.userProfile.consumerDeliveryFees) this.consumerDeliveryFees = this.userProfile.consumerDeliveryFees
                if (this.userProfile.consumerDeliveryTime) this.consumerDeliveryTime = this.userProfile.consumerDeliveryTime
                if(this.userProfile.consumerShippingTime) this.consumerShippingTime = this.userProfile.consumerShippingTime
                if(this.userProfile.minForFreeDelivery) this.minForFreeDelivery = this.userProfile.minForFreeDelivery
                if(this.userProfile.minForFreeShipping) this.minForFreeShipping = this.userProfile.minForFreeShipping
                if(this.userProfile.case1ShippingSize) this.case1ShippingSize = this.userProfile.case1ShippingSize
                if(this.userProfile.case1ShippingCost) this.case1ShippingCost = this.userProfile.case1ShippingCost
                if(this.userProfile.case2ShippingSize) this.case2ShippingSize = this.userProfile.case2ShippingSize
                if(this.userProfile.case2ShippingCost) this.case2ShippingCost = this.userProfile.case2ShippingCost
                if(this.userProfile.case3ShippingSize) this.case3ShippingSize = this.userProfile.case3ShippingSize
                if(this.userProfile.case3ShippingCost) this.case3ShippingCost = this.userProfile.case3ShippingCost
                if(this.userProfile.case4ShippingSize) this.case4ShippingSize = this.userProfile.case4ShippingSize
                if(this.userProfile.case4ShippingCost) this.case4ShippingCost = this.userProfile.case4ShippingCost
                if(this.userProfile.kegDeposit) this.kegDeposit = this.userProfile.kegDeposit

                if(!this.userProfile.pickupAddress){
                    this.pickupAddress = this.userProfile.street1
                        
                        if (this.userProfile.street2){
                            this.pickupAddress  = this.pickupAddress  + ' ' + this.userProfile.street2
                        }
                        this.pickupAddress  = this.pickupAddress  + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip
                    
                }
                else this.pickupAddress = this.userProfile.pickupAddress
                return 

            },
        },
        methods: {

            //Update delivery and shipping options
            updateDelivery(){
                //Check for errors
                this.hasError = false; this.invalidDeliveryFees=false; this.invalidDeliveryTime=false; this.invalidShippingFees=false; this.invalidMinimumDelivery=false;
                this.invalidShippingTime = false; this.invalidMinimumFreeShipping=false; this.invalidKegDeposit=false;
                this.consumerEntryError=false

                //If sell to consumers, check if at least one of deliver, ship or pickup is allowed
                if(this.sellToConsumers){
                    if(!this.willShip&&!this.willDeliver&&!this.willPickup){
                        this.$bvModal.show("modal-errorconsumer")
                        
                        return

                    }
                }

                //Check that fields for willDeliver are entered
                if(this.willDeliver){
                    if(!this.consumerDeliveryFees||isNaN(this.consumerDeliveryFees)||this.consumerDeliveryFees<0||isNaN(this.minForFreeDelivery)){
                        this.invalidDeliveryFees=true
                        this.$bvToast.toast('ERROR', {
                            title: 'Please Check Delivery Field Errors',
                            solid:true,
                            variant: 'danger',
                            autoHideDelay: 5000,
                            appendToast: false
                            })
                            this.consumerEntryError=true
                        return
                    } 
                    
                }
                //Check shipping cost within state
                if(this.willShip){
                    if(!this.case1ShippingSize&&!this.case2ShippingSize&&!this.case3ShippingSize&&!this.case4ShippingSize){
                        this.invalidShippingFees = true
                        this.$bvToast.toast('ERROR', {
                            title: 'Please Check Shipping Field Errors',
                            solid:true,
                            variant: 'danger',
                            autoHideDelay: 5000,
                            appendToast: false
                            })
                            this.consumerEntryError=true
                        return
                    }
                }

                var updateDict = {}

                //Check keg deposit
                if(this.kegDeposit&&isNaN(this.kegDeposit)) {this.invalidKegDeposit=true; this.hasError=true; this.consumerEntryError=true; return}
                updateDict.kegDeposit = this.kegDeposit
                
                if(isNaN(this.consumerDeliveryFees)) {this.invalidDeliveryFees=true; this.hasError=true}
                if(isNaN(this.consumerDeliveryTime)) {this.invalidDeliveryTime=true; this.hasError=true}
                if(isNaN(this.consumerShippingTime)) {this.invalidShippingTime=true; this.hasError=true}
                if(isNaN(this.minForFreeDelivery)) {this.invalidMinimumDelivery=true; this.hasError=true}
                if(isNaN(this.minForFreeShipping)) {this.invalidMinimumFreeShipping=true; this.hasError=true}

                //Check case size errors
                this.case1Error=false
                this.case2Error=false
                this.case3Error=false
                this.case4Error=false

                //Set sell to consumers
                if(this.sellToConsumers) updateDict.sellToConsumers = this.sellToConsumers
                else updateDict.sellToConsumers = 0

                if(this.case1ShippingSize) this.case1ShippingCost = parseFloat(this.case1ShippingCost)
                if(this.case2ShippingSize) this.case2ShippingCost = parseFloat(this.case2ShippingCost)
                if(this.case3ShippingSize) this.case3ShippingCost = parseFloat(this.case3ShippingCost)
                if(this.case4ShippingSize) this.case4ShippingCost = parseFloat(this.case4ShippingCost)

                if(this.case1ShippingSize&&isNaN(this.case1ShippingCost)) this.case1Error=true
                else{
                    updateDict.case1ShippingSize = this.case1ShippingSize
                    updateDict.case1ShippingCost = this.case1ShippingCost
                }
                if(this.case2ShippingSize&&isNaN(this.case2ShippingCost)) this.case2Error=true
                else{
                    updateDict.case2ShippingSize = this.case2ShippingSize
                    updateDict.case2ShippingCost = this.case2ShippingCost
                }
                if(this.case3ShippingSize&&isNaN(this.case3ShippingCost)) this.case3Error=true
                else{
                    updateDict.case3ShippingSize = this.case3ShippingSize
                    updateDict.case3ShippingCost = this.case3ShippingCost
                }
                if(this.case4ShippingSize&&isNaN(this.case4ShippingCost)) this.case4Error=true
                else{
                    updateDict.case4ShippingSize = this.case4ShippingSize
                    updateDict.case4ShippingCost = this.case4ShippingCost
                }

                
                if(this.hasError||this.case1Error||this.case2Error||this.case3Error||this.case4Error) return

                //No errors, proceed
                updateDict.willShip=this.willShip
                updateDict.willDeliver=this.willDeliver
                updateDict.willPickup=this.willPickup
                
                updateDict.consumerDeliveryFees = this.consumerDeliveryFees
                updateDict.consumerDeliveryTime = this.consumerDeliveryTime
                updateDict.consumerShippingTime = this.consumerShippingTime
                updateDict.minForFreeDelivery = this.minForFreeDelivery
                updateDict.minForFreeShipping = this.minForFreeShipping
                updateDict.pickupAddress = this.pickupAddress

                fb.usersCollection.doc(this.currentUser.uid).update(updateDict)

                //Update all beverages of this user
                //If brewer removed sell to consumer, set all allowConsumers=0
                if(this.sellToConsumers==0){
                    updateDict.allowConsumers=0
                    updateDict.consumerBarrel1 = 0
                    updateDict.consumerBarrel2 = 0
                    updateDict.consumerCan = 0
                    updateDict.consumerBottle = 0
                }
                fb.beersCollection.where('uid', '==', this.currentUser.uid).get().then(resp => {
                    let batch = fb.db.batch();
                    resp.docs.forEach(userDocRef => {
                        batch.update(userDocRef.ref, updateDict);
                    })
                    batch.commit().catch(err => console.error(err));
                    
                }).catch(error => console.error(error))

                this.$bvToast.toast('Shipping and delivery updated', {
                            title: 'Shipping and Delivery',
                            solid:true,
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: false
                            })

            },

            //Sales sheet PDF uploaded
            salesSheetUploadComplete(fileURL){
                fb.usersCollection.doc(this.currentUser.uid).update({
                    salesSheetPdfUploaded:1,
                    salesSheetPdfUrl:fileURL
                })
                console.log("Uploaded")
                this.$bvToast.toast('Uploaded', {
                            title: 'Sales Sheet Uploaded',
                            solid:true,
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: false
                            })

            },
            //Sales sheet file format error
            fileFormatError(){
                this.$bvModal.show("modal-fileformaterror")
            },

            //Go to a beer component
            goToGeer(beerId){
                this.$root.$emit('bv::toggle::collapse', 'collapse-beer'+beerId)

                console.log("Clicked go to ID " + beerId)
                
                document.getElementById('beercomponentbuttondiv'+beerId).scrollIntoView();
                //document.getElementById('collapse-beer'+beerId).scrollIntoView();
            },


        }
    }
</script>

<style scoped>
    .errorclass{
        color:red;
    }
</style>